<template lang="pug">
  .box
    .blockOne
      .oneHeader
        h3 产品概述
        .blue
      .oneBody
        img(src="../../assets/images/college/f1.jpg" alt="")
        p 速云课堂以钉钉工作台为统一入口，是一套完整的培训学习系统，多端互通、权限清晰，致力于政企等学习型组织建设，通过移动互联网技术与新型学习方式相结合，轻松实现在线学习，考试、积分、证书等应用管理，打破空间限制，满足各类教育培训在线场景。多元化满足组织的人才发展需求，提升组织竞争实力，帮助众多用户，快速完成线下和线上的学习需求深耕并专注在线教育，助力政企开启全新培训新模式。
    .blockTwo
      .twoHeader
        h3 产品特点
        .blue
      .twoBody
        .pBox
          p 平台+内容+运营，一站式解决政企培训学习难题
          p 以高效率、低成本、覆盖广的方式，助力政企赋能员工
        .imgs
          img(src="../../assets/images/college/f2.jpg" alt="")
          img(src="../../assets/images/college/f3.jpg" alt="")
          img(src="../../assets/images/college/f4.jpg" alt="")
    .blockOne
      .oneHeader(style="margin-top:30px;")
        h3 产品功能
        .blue
      .onesBody
        .one
          h3 1. 学习任务
          img(src="../../assets/images/college/f7.jpg" alt="" style="width: 40%;")
          img(src="../../assets/images/college/f8.jpg" alt="" style="margin-left: 230px;")
          .up
            h4 一体化培训
            span 通过线上学习、线下培训、考试、调查评估等组合，完成教育设计的流程线上化
          .left
            h4 考学一体
            span 每一门课程都可以关联小测验，也可以单独创建考试检验学习效果
          .bottom
            h4 智能排序
            span 根据用户近期学习动态，系统智能分类留痕，方便快速查询
          .right
            h4 定制规划学习路径
            span 对每个阶段的学习制定学习计划，可自定义添加课程、考试、问卷等内容，便于学员统一学习
        .two
          h3 2. 我的课程
          img(src="../../assets/images/college/f5.jpg" alt="")
          img(src="../../assets/images/college/f6.jpg" alt="" style="width: 20%;")
          span  课程根据管理员分派和自主选择自动折叠分类，课程学习状态及进度实时更新，一目了然，清晰直观，课程学分/积分系统自动同步累加，显示课程学习进度并智能排名
        .three
          h3 3. 考试安排
          img(src="../../assets/images/college/f9.jpg" alt="")
          .pBox
            p 管理排课基础信息：班级教学计划中的课程、教师、周课时信息导入。可设置课程的单堂和连堂课时，对应的课节类型、单双周和上课教室将某几门课程打包作为一个课程进行排课，并关联其它班级做冲突校验。
            p 排课规则：可按照课程、教师、班级来设置某个时间段不排课，选择某两个时间段不能排连堂课。
            p 手工预排：从课程维度设置其教师在哪些时间段已经排课。
            p 自动排课：根据基础信息、规则、预排进行自动排课，检测冲突并对应提示。
            p 手工调课：从班级维度调整其课表，提示可对调、可安排的课程。
            p 查看课表：可按班级、教师、学生视图及总课表查看。
        .four
          h3 4. 资源安排
          .pBox
            p （1）课程安排灵活：支持必修、选修课程等多种课程形式，学习时间、学分配置简单。
            p （2）课程可安排到岗位、部门、具体人员，防挂机模式可防止学员作弊。
            p （3）依托大数据技术，系统智能分析学员兴趣和行为特征智能推送学习资源。
          img(src="../../assets/images/college/f10.jpg" alt="")
        .five
          h3 5. 知识库
          img.imgOne(src="../../assets/images/college/f11.png" alt="")
          img.imgTwo(src="../../assets/images/college/f12.jpg" alt="")
        .six
          h3 6. 我的考试
          .pBox
            h4 搭建题库
            p 批量导入，创建题库
            h4 自由组卷
            p 设置参数，智能组卷
            h4 安排考试
            p 制定计划，安排时间
            h4 智能评估
            p 自动阅卷，智能排名
          img(src="../../assets/images/college/f13.jpg" alt="")
    .blockTwo(style="background-color:#f2f2f2;")
      .twoHeader
        h3 产品特点
        .blue
      .twoBody
        img(src="../../assets/images/college/f14.jpg" alt="")
        .one
          h4 海量课程 实时更新
          p 系统拥有庞大的知识资源库，针对各行各业特色和不同的业务需求，根据发展趋势，及时更新课程
        .two
          h4 培训高效 一键操作
          p 可一键创建学习计划，系统提供课程指导，碎片化时间高效学习，一键导出成绩
        .three
          h4 技术领先 安全保障
          p 拥有行业领先的核心技术、一流的技术人才和成熟的安全运维体系
        .four
          h4 多端互通 权限清晰
          p 权限控制极度灵活，支持功能、数据权限控制，数据隔离，各分公司数据互不影响，总部实时查看汇总数据
        .five
          h4 积分排名 激励创新
          p 用户通过学习、培训、考试、登录签到等方式获得积分，积分累加，生成在线排行榜，提高学习竞争力
        .six
          h4 数据看板 智慧决策
          p 报表可视化，随时监控学习进度;自动统计并分析学习数据、科学分析、辅助决策
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('changeNavOther', 3)
  }
}
</script>

<style lang="less" scoped>
  .blockOne{
    width: 70%;
    margin: 0 auto 68px;
    .oneHeader{
      font-size: 20px;
      padding-bottom: 30px;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .oneBody{
      position: relative;
      overflow: hidden;
      height: 454px;
      img{
        float: right;
        width: 80%;
        margin-right: 36px;
      }
      p{
        position: absolute;
        bottom: 12px;
        left: 36px;
        width: 35%;
        padding: 20px;
        border: 3px solid #409fee;
        text-align: justify;
        text-indent: 2em;
      }
    }
    .onesBody{
      .one{
        overflow: hidden;
        position: relative;
        img{
          width: 20%;
          float: left;
        }
        .up,.left,.bottom,.right{
          position: absolute;
          width: 130px;
          text-align: justify;
          font-size: 14px;
          h4{
            font-size: 16px;
            font-weight: 400;
            margin: 10px;
            text-align: center;
          }
        }
        .up{
          top: 0px;
          right: 345px;
          h4{
            color: mediumpurple;
          }
        }
        .right{
          top: 68px;
          right: 0px;
          h4{
            color: palevioletred;
          }
        }
        .bottom{
          bottom: 20px;
          right: 0px;
          h4{
            color: coral;
          }
        }
        .left{
          top: 166px;
          right: 345px;
          h4{
            color: skyblue;
          }
        }
      }
      .two{
        overflow: hidden;
        h3{
          margin: 10px 0;
          text-align: right;
        }
        img{
          width: 40%;
          float: left;
          margin-left: 66px;
        }
        span{
          float: left;
          width: 45%;
          text-align: justify;
          text-indent: 2em;
          margin-top: 20px;
          margin-left: 10px;
          padding: 10px;
          border: 2px solid #409fee;
          border-radius: 10px;
        }
      }
      .three{
        overflow: hidden;
        h3{
          margin: 10px 0;
        }
        img{
          width: 40%;
          float: left;
        }
        .pBox{
          width: 50%;
          float: left;
          text-align: justify;
          font-size: 14px;
          margin-left: 50px;
          p{
            line-height: 26px;
            margin-bottom: 10px;
          }
        }
      }
      .four{
        overflow: hidden;
        h3{
          text-align: right;
          margin: 10px 0;
        }
        .pBox{
          float: left;
          width: 45%;
          padding: 60px 20px 30px;
          background-image: url(../../assets/images/platform/bc3.jpg);
          background-size: cover;
          margin-top: 20px;
          P{
            text-align: justify;
            line-height: 26px;
            margin-bottom: 6px;
          }
        }
        img{
          float: right;
        }
      }
      .five{
        position: relative;
        h3{
          margin: 10px 0;
        }
        .imgTwo{
          display: block;
          width: 35%;
          margin: 100px auto;
        }
        .imgOne{
          position: absolute;
          top: 68px;
          left: 128px;
          width: 75%;
        }
      }
      .six{
        overflow: hidden;
        h3{
          text-align: right;
          margin: 10px 0;
        }
        .pBox{
          float: left;
          width: 16%;
          margin-top: 20px;
          border: 2px solid #409fee;
          padding: 20px;
          border-radius: 10px;
          margin-left: 100px;
          P{
            text-align: justify;
            line-height: 26px;
            margin-bottom: 10px;
          }
        }
        img{
          float: right;
          width: 50%;
          margin: 50px 60px 0 0;
        }
      }
    }
  }
  .blockTwo{
    padding: 0 15% 30px;
    background-color: #ededed;
    .twoHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
        text-align: right;
      }
      .blue{
        float: right;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .twoBody{
      position: relative;
      img{
        display: block;
        margin: 20px auto 0;
      }
      .pBox{
        font-size: 18px;
        text-align: center;
        p{
          margin-top: 15px;
        }
      }
      .imgs{
        overflow: hidden;
        margin-top: 20px;
        img{
          float: left;
          width: 20%;
          margin-left: 92px;
          margin-top: 0;
        }
      }
      .one,.two,.three,.four,.five,.six{
        position: absolute;
        width: 30%;
        p{
          font-size: 14px;
        }
      }
      .one{
        top: -30px;
        left: 0px;
      }
      .two{
        top: 75px;
        left: 0px;
      }
      .three{
        bottom: 56px;
        left: 0px;
      }
      .four{
        top: -15px;
        right: 0px;
      }
      .five{
        top: 75px;
        right: -10px;
      }
      .six{
        bottom: 56px;
        right: 0px;
      }
    }
  }
</style>
